// Function loadTimelineCarousel loads the TimelineCarousel class by dynamically importing the js on demand if needed

export function loadTimelineCarousel($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-timeline-carousel-chunk" */ '../widgets/timelineCarousel').then(wg => {

		const { TimelineCarousel } = wg;

		let $wg = $parentEl.querySelector('[data-wg="TimelineCarousel"]');

		if(!$wg) {
			// console.info('TimelineCarousel: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="TimelineCarousel"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new TimelineCarousel($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new TimelineCarousel($wg);
		}


	}).catch(error => error+'An error occurred while loading the TimelineCarousel widget');

}
